<template>
  <!-- Toggle between copying decisions for all products or filtered products only -->
  <v-btn-toggle :model-value="selectedToggle" mandatory @update:model-value="toggleSelected">
    <v-btn class="border-e-thin" :value="toggleOptions.allProducts">
      {{ tkey('allProductsToggle') }}
    </v-btn>

    <v-tooltip :disabled="!disableFilteredProductsToggle" location="bottom">
      <template #activator="{ props: activatorProps }">
        <span v-bind="activatorProps">
          <v-btn :value="toggleOptions.filteredProducts" :disabled="disableFilteredProductsToggle">
            {{ tkey('filteredProductsToggle') }}
          </v-btn>
        </span>
      </template>
      <p class="tooltip__message">
        {{ tkey('noFilteredProductsTooltip') }}
      </p>
    </v-tooltip>
  </v-btn-toggle>
</template>

<script setup>
import { defineEmits } from 'vue';
import { useInternationalization } from '@/composables/use-internationalization';

import toggleOptions from '@sharedModules/data/enums/copy-decisions-modal-toggle-options';

defineProps({
  selectedToggle: {
    type: String,
    required: true,
  },
  disableFilteredProductsToggle: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['toggle-selected']);

const { tkey } = useInternationalization('productModellingPage.copyDecisionsModal');

const toggleSelected = value => {
  emit('toggle-selected', value);
};
</script>

<style lang="scss" scoped>
.tooltip {
  &__message {
    font-size: 1.25rem;
  }
}
</style>
